module.exports = "static/assets/cf07199bb768b01e6ac2a5c68fd8c3bb.svg";